import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

export const fetchComponents = createAsyncThunk(
    'componentsRepo/fetchComponents',
    async (activeScreenSlug) => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/page/component-repository`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            params: {page_slug: activeScreenSlug},
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })

    }
);